const configuredApiUrl = (process.env.VUE_APP_API_BASE_URL || "").replace(/\/$/, "");

export const API_BASE_URL = configuredApiUrl || "/api";
